<template>
  <div class="column_end_start general_card" :class="{ vip_card: isLogin && vipLevel > 1 }">
    <div class="row_center_between member_type">
      <GeneralMemberType v-if="vipLevel === 1"></GeneralMemberType>
      <VipMemberType v-else></VipMemberType>
      <div v-if="!isLogin"></div>
      <div class="row_center_end shop_name" :style="{ color: vipLevel > 1 && isLogin ? '#FACB00' : '#fff' }">
        {{ storeName }}
      </div>
    </div>
    <div class="row_center_start userInfo_container">
      <div class="row_center_center shrink-0">
        <img :src="avatar" alt="" class="avatar" v-if="isLogin && avatar" />
        <text class="row_center_center button-icon avatar" style="background-color: #eeeeee;"
          v-if="!avatar || !isLogin">account_circle</text>
      </div>
      <div class="column_center_center sub_userInfo" v-if="isLogin">
        <div class="row_center_start" style="width: 100%;">
          <text class="user_name">{{ name }}</text>
        </div>
        <div class="row_center_start" style="width: 100%;">
          <text class="user_phone">{{ phone }}</text>
        </div>

      </div>
      <div class="column_start_center sub_userInfo" v-else>
        <text style="font-weight: 700; font-size: 18px; margin-bottom: 12px;">VIP會員卡</text>
        <!-- <text style="font-weight: 400; font-size: 13px;">未提供手機號碼</text> -->
      </div>
    </div>
  </div>
</template>
<script>
import generalMemberType from "../general/generalMemberType.vue";
import vipMemberType from "../general/vipMemberType.vue";
import {
  mapState,
  mapGetters,
} from 'vuex';
export default {
  components: {
    GeneralMemberType: generalMemberType,
    VipMemberType: vipMemberType,
  },
  computed: {
    ...mapState('userData', {
      userInfo: 'userInfo',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin',
      vipLevel: 'vipLevel',
      phone: 'phone',
      name: 'name',
      avatar: 'avatar',
    }),
    ...mapGetters('basic', {
      storeName: 'storeName'
    })
  },
  data() {
    return {
    };
  },
  async mounted() {
  },
};
</script>
<style lang="scss" scoped>
.general_card {
  width: 90vw;
  height: 220px;
  border-radius: 20px;
  background-image: url("@/assets/card_background.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #fd5001;
  margin: 0 auto;
}

.vip_card {
  width: 90vw;
  height: 220px;
  margin: 0 auto;
  border-radius: 20px;
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("@/assets/vip-card0206.png"),
    linear-gradient(180deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(64, 64, 64, 1) 60%,
      rgba(0, 0, 0, 1) 100%);
}

.member_type {
  width: 94%;
  margin-top: 20px;
  color: #000;
  font-size: 12px;
}

.shop_name {
  flex-grow: 1;
  height: 32px;
  padding: 5px 20px 5px 0;
  text-align: right;
  background-image: url("@/assets/shop_name_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: rgba($color: #fff, $alpha: 0.7);
  font-size: 16px;
  font-weight: 500;
  flex-shrink: 0;
}

.userInfo_container {
  width: 94%;
  margin-top: 10px;
}

.sub_userInfo {
  margin-left: 10px;
  flex-grow: 1;
  color: #fff;
  letter-spacing: 2px;
  overflow: hidden;
  padding-right: 15px;
}

.user_name {
  font-weight: 700;
  font-size: 18px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 0 0 5px 0;
}

.user_phone {
  margin: 5px 0 0 0;
  flex-shrink: 0;
  font-weight: 400;
  font-size: 13px;
  text-decoration: none;
  text-align: left;
}

.avatar {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 6px solid #facb00;
  font-size: 91px;
  color: #fff;
}
</style>
